import { Injectable } from '@angular/core';
import { AppService } from '../shared/service/AppService.class';
import { HttpClient } from '@angular/common/http';
import { APIURL } from '../app-routing.module';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { Option } from '../shared/model/model.class';
@Injectable({
  providedIn: 'root'
})
export class WizardService extends AppService<any>{
  constructor(protected http: HttpClient) {
    super(http);
    // if(sessionStorage.getItem("type")=="3")
    //   this.appmod="usersmgm";
    // else
    this.appmod = "wizard";
  }

  public updateUser(data: any): Observable<any> {
    let tmp = this.appmod;
    this.appmod = "custom/updateuser";
    let savecomp = this.updateService(data);
    this.appmod = tmp;
    return savecomp;
  }
}
